<template>
     <div data-vue="app">
    </div>
</template>

<script>
export default {
    name:'App'
}
</script>